import { ApiProperty } from "@nestjs/swagger";

export class BarcodeReq{
    @ApiProperty()
    barcode:string;
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    itemId:number;
}